export const ersteBL = [
    "Berliner RC",
    "Hannover 78",
    "SC Germania List",
    "Heidelberger Ruderklub 1872",
    "München RFC",
    "Rugby Club Luxembourg",
    "RG Heidelberg",
    "SC Frankfurt 1880",
    "SC Neuenheim",
    "TSV Handschuhsheim"
]
export const zweiteBLNO = [
    "BSV 1892 Rugby",
    "FC St. Pauli",
    "Hamburger Rugby-Club",
    "RC Leipzig",
    "RK 03 Berlin",
    "TSV Victoria Linden",
    "SG Rugbyunion Hohen Neuendorf e.V."
]
export const zweiteBLSW = [
    "RSV Köln",
    "Heidelberger Turnverein",
    "RC Unterföhring",
    "RK Heusenstamm",
    "Rugby-Club Rottweil",
    "Walferdange Rugby Seniors",
    "StuSta Rugby",
    "Sport-Union Neckarsulm",
]
